import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';
import { getPhotosFromIndexedDB, deleteAllPhotosFromIndexedDB } from "../utils/indexDB"

export interface CreatePropertyOwnerDocumentData {
  propertyId: number
  ownerId?: number
  contactId: number
  houseAddress?: string
  cadastralReference?: string
  hasDebts: boolean
  municipalTaxesStatus?: string
  preferredSaleMethod?: string
  bankName?: string
  commissionPercentage: number
  createdByBrokerId: number
}

// Crear documento del propietario
export const createPropertyOwnerDocument2 = async (data: CreatePropertyOwnerDocumentData) => {
  try {
    // Crear FormData
    const formData = new FormData()

    // Agregar todos los campos del DTO
    formData.append("PropertyId", data.propertyId.toString())
    formData.append("ContactId", data.contactId.toString())
    formData.append("CreatedByBrokerId", data.createdByBrokerId.toString())
    formData.append("HasDebts", data.hasDebts.toString())
    formData.append("CommissionPercentage", data.commissionPercentage.toString())

    if (data.ownerId) {
      formData.append("OwnerId", data.ownerId.toString())
    }
    if (data.houseAddress) {
      formData.append("HouseAddress", data.houseAddress)
    }
    if (data.cadastralReference) {
      formData.append("CadastralReference", data.cadastralReference)
    }
    if (data.municipalTaxesStatus) {
      formData.append("MunicipalTaxesStatus", data.municipalTaxesStatus)
    }
    if (data.preferredSaleMethod) {
      formData.append("PreferredSaleMethod", data.preferredSaleMethod)
    }
    if (data.bankName) {
      formData.append("BankName", data.bankName)
    }

    const photos = await getPhotosFromIndexedDB()
    if (photos.length > 0) {
      formData.append("Documents", photos[0])
    }

    for (const pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`)
    }

    const response = await axios.post(`${API_URL}/PropertyOwnerDocuments/create-document`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })

    await deleteAllPhotosFromIndexedDB()

    return response
  } catch (error: any) {
    console.error("Error al crear documento:", error)

    if (error.response) {
      console.error("Respuesta de error del servidor:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      })
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request)
    } else {
      console.error("Error al configurar la solicitud:", error.message)
    }

    handleAuthError(error)
    throw error
  }
}

export const createContactForOwner = async (formData: FormData) => {
  for (const pair of formData.entries()) {
    console.log(`${pair[0]}: ${pair[1]}`)
  }

  try {
    const response = await axios.post(`${API_URL}/contact/create-contact-owner`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })

    return response
  } catch (error: any) {
    console.error("Error al crear contacto:", error)

    if (error.response) {
      console.error("Respuesta de error del servidor:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      })
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request)
    } else {
      console.error("Error al configurar la solicitud:", error.message)
    }

    handleAuthError(error);
    return undefined
  }
}

// Obtener documentos por ID de propiedad
export const getDocumentsByPropertyId = async (propertyId: string) => {
  try {
    const response = await axios.get(`${API_URL}/PropertyOwnerDocuments/get-by-property/${propertyId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    console.error("Error al obtener documentos:", error);
    return null;
  }
};

// Obtener contacto por número de teléfono
export const getContactByPhone = async (phone: string) => {
  try {
    const response = await axios.get(`${API_URL}/Contact/get-by-phone/${phone}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    console.error("Error al obtener contacto por teléfono:", error);
    
    if (error.response && error.response.status === 404) {
      return null;
    }
    
    return null;
  }
};

// Actualizar dirección de la casa
export const updateHouseAddress = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-house-address`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar dirección:", error);
    handleAuthError(error);
    return undefined;
  }
};

export interface UpdateCadastralReferenceData {
  documentId: number;
  cadastralReference?: string;
}

export const updateCadastralReference = async (data: UpdateCadastralReferenceData) => {
  try {
    
    // Crear FormData
    const formData = new FormData();

    // Agregar campos requeridos
    formData.append("DocumentId", data.documentId.toString());
    
    if (data.cadastralReference) {
      formData.append("CadastralReference", data.cadastralReference);
    }

    // Obtener imágenes de IndexedDB y agregar solo la primera
    const photos = await getPhotosFromIndexedDB();
    if (photos.length > 0) {
      formData.append("Documents", photos[0]);
    }

    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    // 👇 CAMBIAR DE PUT A POST
    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-cadastral-reference`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );
    
    // Limpiar IndexedDB después de envío exitoso
    await deleteAllPhotosFromIndexedDB();
    
    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar referencia catastral:", error);
    
    if (error.response) {
      console.error("Respuesta de error del servidor:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      });
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request);
    } else {
      console.error("Error al configurar la solicitud:", error.message);
    }
    
    handleAuthError(error);
    throw error;
  }
};
// Actualizar estado de deudas
export const updateHasDebts = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-has-debts`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar estado de deudas:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar estado de impuestos municipales
export const updateMunicipalTaxesStatus = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-municipal-taxes-status`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar estado de impuestos:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar método de venta preferido
export const updatePreferredSaleMethod = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-preferred-sale-method`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar método de venta:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar nombre del banco
export const updateBankName = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-bank-name`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar nombre del banco:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar porcentaje de comisión
export const updateCommissionPercentage = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-commission-percentage`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );
    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar porcentaje de comisión:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar contacto
export const updateContact = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-contact`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );

    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar contacto:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Actualizar propietario
export const updateOwner = async (formData: FormData) => {
  try {
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyOwnerDocuments/update-owner`,
      formData,
      { 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    );
    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar propietario:", error);
    handleAuthError(error);
    return undefined;
  }
};

// Función de manejo de errores de autenticación (comentada)

const handleAuthError = (error: any) => {
  console.log(error);
  if (error.response) {
    throw new Error(error.response.data.message || error.message); 
  } else {
    throw new Error(error.message || 'An unknown error occurred');
  }
};


export {};